const prod = {
  url: {
    API_URL: "https://api.haydenjeune.com",
    APP_URL: "https://todo.haydenjeune.com",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:5000",
    APP_URL: "http://localhost:3000",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
